// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ReleaseMinified,
  ReleaseMinifiedFromJSON,
  ReleaseMinifiedToJSON,
  ReleaseReadinessComparison,
  ReleaseReadinessComparisonFromJSON,
  ReleaseReadinessComparisonToJSON,
  ReleaseReadinessConfigurationCoverage,
  ReleaseReadinessConfigurationCoverageFromJSON,
  ReleaseReadinessConfigurationCoverageToJSON,
  ReleaseReadinessCoverageItem,
  ReleaseReadinessCoverageItemFromJSON,
  ReleaseReadinessCoverageItemToJSON,
  ReleaseReadinessCustomFieldCoverage,
  ReleaseReadinessCustomFieldCoverageFromJSON,
  ReleaseReadinessCustomFieldCoverageToJSON,
  ReleaseReadinessDefects,
  ReleaseReadinessDefectsFromJSON,
  ReleaseReadinessDefectsToJSON,
  ReleaseReadinessEvidence,
  ReleaseReadinessEvidenceFromJSON,
  ReleaseReadinessEvidenceToJSON,
  ReleaseReadinessRequirementCoverage,
  ReleaseReadinessRequirementCoverageFromJSON,
  ReleaseReadinessRequirementCoverageToJSON,
  ReleaseReadinessRunHistory,
  ReleaseReadinessRunHistoryFromJSON,
  ReleaseReadinessRunHistoryToJSON,
  ReleaseReadinessSummary,
  ReleaseReadinessSummaryFromJSON,
  ReleaseReadinessSummaryToJSON,
  ReleaseReadinessTestPlan,
  ReleaseReadinessTestPlanFromJSON,
  ReleaseReadinessTestPlanToJSON,
  ReleaseReadinessVerdict,
  ReleaseReadinessVerdictFromJSON,
  ReleaseReadinessVerdictToJSON,
} from "./";

/**
 * Aggregated readiness data for a release. Combines execution results, defect counts, coverage analysis, evidence metrics, and a computed Go/No-Go verdict across all test plans in the release.
 * @export
 * @interface ReleaseReadiness
 */
export interface ReleaseReadiness {
  /**
   *
   * @type {ReleaseMinified}
   * @memberof ReleaseReadiness
   */
  release: ReleaseMinified;
  /**
   *
   * @type {ReleaseReadinessSummary}
   * @memberof ReleaseReadiness
   */
  summary: ReleaseReadinessSummary;
  /**
   *
   * @type {ReleaseReadinessDefects}
   * @memberof ReleaseReadiness
   */
  defects: ReleaseReadinessDefects;
  /**
   *
   * @type {Array<ReleaseReadinessCoverageItem>}
   * @memberof ReleaseReadiness
   */
  coverage: Array<ReleaseReadinessCoverageItem>;
  /**
   *
   * @type {ReleaseReadinessEvidence}
   * @memberof ReleaseReadiness
   */
  evidence: ReleaseReadinessEvidence;
  /**
   *
   * @type {ReleaseReadinessComparison}
   * @memberof ReleaseReadiness
   */
  comparison?: ReleaseReadinessComparison;
  /**
   *
   * @type {ReleaseReadinessVerdict}
   * @memberof ReleaseReadiness
   */
  verdict: ReleaseReadinessVerdict;
  /**
   *
   * @type {Array<ReleaseReadinessTestPlan>}
   * @memberof ReleaseReadiness
   */
  testPlans: Array<ReleaseReadinessTestPlan>;
  /**
   *
   * @type {ReleaseReadinessRequirementCoverage}
   * @memberof ReleaseReadiness
   */
  requirementCoverage?: ReleaseReadinessRequirementCoverage;
  /**
   * Coverage breakdown by non-text custom fields. Only present when eligible custom fields exist for the project.
   * @type {Array<ReleaseReadinessCustomFieldCoverage>}
   * @memberof ReleaseReadiness
   */
  customFieldCoverage?: Array<ReleaseReadinessCustomFieldCoverage>;
  /**
   *
   * @type {ReleaseReadinessRunHistory}
   * @memberof ReleaseReadiness
   */
  runHistory?: ReleaseReadinessRunHistory;
  /**
   * Coverage breakdown by test plan configuration. Only present when test plans in the release have configurations defined.
   * @type {Array<ReleaseReadinessConfigurationCoverage>}
   * @memberof ReleaseReadiness
   */
  configurationCoverage?: Array<ReleaseReadinessConfigurationCoverage>;
}

export function ReleaseReadinessFromJSON(json: any): ReleaseReadiness {
  return {
    release: ReleaseMinifiedFromJSON(json["release"]),
    summary: ReleaseReadinessSummaryFromJSON(json["summary"]),
    defects: ReleaseReadinessDefectsFromJSON(json["defects"]),
    coverage: (json["coverage"] as Array<any>).map(
      ReleaseReadinessCoverageItemFromJSON
    ),
    evidence: ReleaseReadinessEvidenceFromJSON(json["evidence"]),
    comparison: !exists(json, "comparison")
      ? undefined
      : ReleaseReadinessComparisonFromJSON(json["comparison"]),
    verdict: ReleaseReadinessVerdictFromJSON(json["verdict"]),
    testPlans: (json["test_plans"] as Array<any>).map(
      ReleaseReadinessTestPlanFromJSON
    ),
    requirementCoverage: !exists(json, "requirement_coverage")
      ? undefined
      : ReleaseReadinessRequirementCoverageFromJSON(
          json["requirement_coverage"]
        ),
    customFieldCoverage: !exists(json, "custom_field_coverage")
      ? undefined
      : (json["custom_field_coverage"] as Array<any>).map(
          ReleaseReadinessCustomFieldCoverageFromJSON
        ),
    runHistory: !exists(json, "run_history")
      ? undefined
      : ReleaseReadinessRunHistoryFromJSON(json["run_history"]),
    configurationCoverage: !exists(json, "configuration_coverage")
      ? undefined
      : (json["configuration_coverage"] as Array<any>).map(
          ReleaseReadinessConfigurationCoverageFromJSON
        ),
  };
}

export function ReleaseReadinessToJSON(value?: ReleaseReadiness): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    release: ReleaseMinifiedToJSON(value.release),
    summary: ReleaseReadinessSummaryToJSON(value.summary),
    defects: ReleaseReadinessDefectsToJSON(value.defects),
    coverage: (value.coverage as Array<any>).map(
      ReleaseReadinessCoverageItemToJSON
    ),
    evidence: ReleaseReadinessEvidenceToJSON(value.evidence),
    comparison: ReleaseReadinessComparisonToJSON(value.comparison),
    verdict: ReleaseReadinessVerdictToJSON(value.verdict),
    test_plans: (value.testPlans as Array<any>).map(
      ReleaseReadinessTestPlanToJSON
    ),
    requirement_coverage: ReleaseReadinessRequirementCoverageToJSON(
      value.requirementCoverage
    ),
    custom_field_coverage:
      value.customFieldCoverage === undefined
        ? undefined
        : (value.customFieldCoverage as Array<any>).map(
            ReleaseReadinessCustomFieldCoverageToJSON
          ),
    run_history: ReleaseReadinessRunHistoryToJSON(value.runHistory),
    configuration_coverage:
      value.configurationCoverage === undefined
        ? undefined
        : (value.configurationCoverage as Array<any>).map(
            ReleaseReadinessConfigurationCoverageToJSON
          ),
  };
}
